var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0"}},[_c('hero-forms'),_c('quem-somos'),_c('missao-valores'),_c('campanhas'),_c('pq-voluntario'),_c('form-voluntario'),_c('form-doacao'),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }